module.exports = __webpack_public_path__ + "img/frozen_broccoli_florets.48609ab3.jpg";